export default __webpack_public_path__ + "static/media/Eina02-SemiboldItalic.52282586.ttf";